<template>
  <div>
    <banner :bgSrc="bannerBg" @toDownload="toDownload" :showCarousel="false"></banner>
    <features />
    <functions />
    <whyChoose />
    <!-- <demand @freeTest="freeTest"/> -->
  </div>
</template>
<script>
import banner from "@/components/banner.vue";
import bannerBg from "@/assets/imgs/home/bannerBg.png";
import features from "@/components/home/features.vue";
import functions from "@/components/home/functions.vue";
import whyChoose from "@/components/home/whyChoose.vue";
// import demand from "@/components/home/demand.vue";
export default {
  name: "home",
  components: {
    features,
    functions,
    whyChoose,
    // demand,
    banner
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bannerBg
    };
  },
  methods: {
    toDownload() {
      this.$emit("toDownload")
    },
    freeTest(){
      this.$emit("on-free-test")
    }
  }
};
</script>
<style scoped>
.main {
  position: relative;
}
.specialityBox {
  background-color: #3581ff;
}
.specialityBox > div {
  background-image: url("../../assets/imgs/home/speciality.png");
  color: var(--vt-c-white);
  font-size: 2.375rem;
  font-weight: 500;
  line-height: 2.875rem;
  letter-spacing: 0em;
  text-align: center;
  padding: 5.4375rem 0;
}
@media (max-width: 768px) {
  .specialityBox > div {
    padding: 1.75rem;
    font-size: 1.67rem;
    line-height: 2.33rem;
  }
}
</style>
